import Axios from "axios";
import { handleApiError } from "./config";

export function listRecipients() {
  return new Promise((resolve, reject) => {
    Axios.get("recipient")
      .then((res) => {
        return resolve(res.data);
      })
      .catch((err) => {
        handleApiError(err)
        return reject(err);
      });
  });
}

export function listRecipientsForNotification(notificationId) {
  return new Promise((resolve, reject) => {
    Axios.get(`recipientForNotifcation/${notificationId}`)
      .then((res) => {
        return resolve(res.data);
      })
      .catch((err) => {
        handleApiError(err)
        return reject(err);
      });
  });
}

export function postContact(name, phone) {
  return new Promise((resolve, reject) => {
    Axios.post("recipient", {
      type: "individual",
      data: {
        name: name,
        phone: phone,
      }
    })
      .then((res) => {
        return resolve(res.data);
      })
      .catch((err) => {
        handleApiError(err)
        return reject(err);
      });
  });
}

export function postGroup(name, ids) {
  return new Promise((resolve, reject) => {
    Axios.post("recipient", {
      type: "group",
      data: {
        name: name,
        ids: ids,
      }
    })
      .then((res) => {
        return resolve(res.data);
      })
      .catch((err) => {
        handleApiError(err)
        return reject(err);
      });
  });
}

export function addRecipientsToGroup(id, ids) {
  return new Promise((resolve, reject) => {
    Axios.patch(`recipient/group/${id}`, {
      ids: ids
    })
      .then((res) => {
        return resolve(res.data);
      })
      .catch((err) => {
        handleApiError(err)
        return reject(err);
      });
  });
}

export function deleteContact(id) {
  return new Promise((resolve, reject) => {
    Axios.delete(`recipient/individual/${id}`)
      .then((res) => {
        return resolve(res.data);
      })
      .catch((err) => {
        handleApiError(err)
        return reject(err);
      });
  });
}

export function deleteGroup(id) {
  return new Promise((resolve, reject) => {
    Axios.delete(`recipient/group/${id}`)
      .then((res) => {
        return resolve(res.data);
      })
      .catch((err) => {
        handleApiError(err)
        return reject(err);
      });
  });
}
